declare global {
  interface Window {
    __APP_CONFIG__?: {
      VODOPAD_ENDPOINT?: string
      FLUENCE_CLIENT_NETWORK?: string
      GPU_ADMIN_ENDPOINT?: string
    }
  }
}

const runtime = (typeof window !== 'undefined' && window.__APP_CONFIG__) || {}

const pick = (
  runtimeValue: string | undefined,
  buildValue: string | undefined,
) => {
  const v = runtimeValue?.trim()
  return v && !v.startsWith('${') ? v : buildValue
}

export const VODOPAD_ENDPOINT =
  pick(runtime.VODOPAD_ENDPOINT, import.meta.env.VITE_VODOPAD_ENDPOINT) ??
  'https://vodopad.testnet.fluence.dev'

export const FLUENCE_CLIENT_NETWORK = pick(
  runtime.FLUENCE_CLIENT_NETWORK,
  import.meta.env.VITE_FLUENCE_CLIENT_NETWORK,
)

export const GPU_ADMIN_ENDPOINT = pick(
  runtime.GPU_ADMIN_ENDPOINT,
  import.meta.env.VITE_GPU_ADMIN_ENDPOINT,
)

export {}
